import {ApiClient} from '@hconnect/apiclient'
import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {ScheduleItem} from '../api'

type Variables = {
  plantCode: string
  scheduleId: number
  scheduleItem: ScheduleItem
}

export const useDeleteScheduleItemMutation = (
  options?: Omit<UseMutationOptions<void, AxiosError, Variables>, 'mutationFn'>
) =>
  useMutation<void, AxiosError, Variables>({
    ...options,
    mutationFn: async ({scheduleId, plantCode, scheduleItem}) => {
      await ApiClient.axiosInstance.delete(`/schedules/${scheduleId}/items/${scheduleItem.id}`, {
        params: {plantCode}
      })
    }
  })
